import { createContext, useState, useEffect } from "react";

export const Dimcontext = createContext();

 export const DimProvider = ({children}) => {
    const [ dim, setDim ] = useState(false);

    useEffect(() => {
    if (dim) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => document.body.classList.remove("no-scroll");
  }, [dim]);

  return(
    <Dimcontext.Provider value={{ dim, setDim }} > 
        {children}
        {dim && <div className="page-dim no-scroll" />}
    </Dimcontext.Provider>
  )
}